export default __webpack_public_path__ + "static/3-c70c8f83b597c926f9d39ea4beb14c3d.jpeg";